/* La Sura - an optional answer left empty isn't sent with the basket line (2026-09-30).
   Horizon's add to basket (product-form.js) and the paid extras (lasura-cake-extras.js)
   both build their request with new FormData(form), which fires a formdata event first.
   Empty text answers ("Your idea", a topper note) are dropped there, so an order never
   carries a blank "Your idea:" line. Files and filled answers are untouched. */
(() => {
  if (window.lasuraEmptyProperties) return;
  window.lasuraEmptyProperties = true;
  document.addEventListener(
    'formdata',
    (event) => {
      for (const [key, value] of [...event.formData.entries()]) {
        if (key.startsWith('properties[') && typeof value === 'string' && !value.trim()) event.formData.delete(key);
      }
    },
    true
  );
})();
